import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "./../../constants/enums";
import { DeleteVideoResponse } from "./deleteVideo.types";

export const requestDeleteVideo = async (
  videoId: string
): Promise<DeleteVideoResponse> => {
  return await instance.delete(buildUrl(ApiRoutesContent.VideoDelete, videoId));
};
